import { backgroundStyles, iconStyles } from 'styles/theme';

import { Badge } from 'antd';
import styled from '@emotion/styled';

export default styled(Badge)({
  color: iconStyles.colors.secondary,
  right: 4,
  '& sup.ant-badge-count': {
    backgroundColor: backgroundStyles.colors.primary,
  },
});
